var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLightning = function SvgLightning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#080A11",
    d: "M15.055.167c.506-.43 1.328.025 1.172.723l-2.09 9.32h4.27c.618 0 .948.728.54 1.192L8.081 23.75c-.497.565-1.421.095-1.257-.64l2.091-9.324H5.22a.718.718 0 0 1-.552-1.177L14.958.265zM6.713 12.369h3.973L8.797 20.79l8.063-9.163h-4.493l1.852-8.263z"
  })));
};
export default SvgLightning;